import cn from 'classnames'
import IconSvg, { IconSvgProps } from 'core/_legacy/icons/IconSvg'

const CrownIcon = ({
  width = '25',
  height = '25',
  color = '#F5A623',
  className = ''
}: Omit<IconSvgProps, 'children'>) => (
  <IconSvg
    width={width}
    height={height}
    xmlns="http://www.w3.org/2000/svg"
    version="1.0"
    x="0px"
    y="0px"
    viewBox="0 0 50 50"
    className={cn('icon icons8-Crown-Filled', className)}
  >
    <g id="surface1">
      <path
        fill={color}
        d="M 25 6 C 22.800781 6 21 7.800781 21 10 C 21 11.183594 21.546875 12.234375 22.375 12.96875 L 15.5 24.875 L 8.71875 21.46875 C 8.898438 21.015625 9 20.515625 9 20 C 9 17.800781 7.199219 16 5 16 C 2.800781 16 1 17.800781 1 20 C 1 22.175781 2.769531 23.964844 4.9375 24 L 7.75 36 L 42.25 36 L 45.0625 24 C 47.230469 23.964844 49 22.175781 49 20 C 49 17.800781 47.199219 16 45 16 C 42.800781 16 41 17.800781 41 20 C 41 20.46875 41.097656 20.925781 41.25 21.34375 L 34.40625 24.78125 L 27.59375 13 C 28.441406 12.265625 29 11.199219 29 10 C 29 7.800781 27.199219 6 25 6 Z M 25 8 C 26.117188 8 27 8.882813 27 10 C 27 11.117188 26.117188 12 25 12 C 23.882813 12 23 11.117188 23 10 C 23 8.882813 23.882813 8 25 8 Z M 5 18 C 6.117188 18 7 18.882813 7 20 C 7 21.117188 6.117188 22 5 22 C 3.882813 22 3 21.117188 3 20 C 3 18.882813 3.882813 18 5 18 Z M 45 18 C 46.117188 18 47 18.882813 47 20 C 47 21.117188 46.117188 22 45 22 C 43.882813 22 43 21.117188 43 20 C 43 18.882813 43.882813 18 45 18 Z M 8 38 L 8 43 C 8 43.554688 8.449219 44 9 44 L 41 44 C 41.554688 44 42 43.554688 42 43 L 42 38 Z "
      />
    </g>
  </IconSvg>
)

export default CrownIcon
